import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils';
import GoogleAdsense from 'app/components/base/GoogleAdsense'
import config from 'config';

export const Container = styled('div', {
  position: 'relative',
  maxWidth: '750px',
  margin: '0 auto',
  zIndex: 5000
});

export const Form = styled('form', () => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '15px',
  borderRadius: '0 0 4px 4px',
  background: config.SEARCHFORM_BACKGROUND_COLOR
}));

export const Fields = styled('div', ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingBottom: '10px'
}));


export const SwapLocations = styled('div', ({ $palette }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  background: 'white',
  color: `${$palette('PRIMARY')}`,
  cursor: 'pointer',
  position: 'absolute',
  top: '52px',
  right: '-10px',
  zIndex: '100',
  width: '20px',
  height: '20px',
  border: `1px solid ${$palette('PRIMARY')}`,
  borderRadius: '50%',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  ...getScreenStyles('xs', {
    marginTop: '-6px',
    position: 'static',
    marginBottom: '-16px',
    alignSelf: 'flex-end',
    marginRight: '10px',
    width: '24px',
    height: '24px',
    transform: 'rotate(90deg)',
  }),
}))

export const PickupDateTime = styled('div', ({
  display: 'flex',
  flexDirection: 'column'
}));

export const Mode = styled('div', ({
  marginTop: '18px',
  marginLeft: '30%'
}));

export const TimeType = styled('div', ({
  borderRadius: '3px 3px 3px 3px',
  overflow: 'hidden',
  marginTop: '4px'
}));

export const SwapContainer = styled('div', ({
  display: 'flex',
  flexFlow: 'column nowrap'
}));

export const ButtonWrapper = styled('div', ({
  alignSelf: 'flex-end',
  minWidth: '25%',
  ...getScreenStyles('xs', {
    marginTop: '10px',
    width: '100%'
  })
}));

export const SearchText = styled('span', ({
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22px',
  textTransform: 'uppercase'
}));

export const Title = styled('h1', {
  color: 'white',
  maxWidth: '750px',
  fontSize: '34px',
  margin: '0 0 15px 0',
  ...getScreenStyles('xs', {
    fontSize: '24px',
    textAlign: 'center'
  })
});

export const StyledAdsense = styled(GoogleAdsense, {
  display: 'block',
  width: '100%',
  marginTop: '20px',
});
